module.exports = __webpack_public_path__ + "static/media/structure.4e6cce95.ogg";